import SlsWebLogger from "js-sls-logger";
import { getUserInfo } from "@/utils/app.js";
import {v4 as uuidV4} from "uuid";
//文档：https://www.teambition.com/project/5fbe213b097d50f8ba67e721/app/5eba5fba6a92214d420a3219/workspaces/5fbe213bf0c5ab004650861b/docs/5fbf24554cc5830001d4ee9a
//重要，每个活动修改为git仓库的英文名,如果有openid需要对接。

const isReleaseEnv =
  "production" === process.env.NODE_ENV &&
  undefined === process.env.VUE_APP_MODE;

const __topic__ = "jkhh_hsj_appweb";

const project = isReleaseEnv ? "jkhh-log-web" : "jkhh-log-test";
const logstore = isReleaseEnv ? "jkhh-h5-log" : "jkhh-test-log";
const opts = {
  host: "cn-beijing.log.aliyuncs.com",
  project: project,
  logstore: logstore,
  time: 10,
  count: 10
};
const logger = new SlsWebLogger(opts);


const localUUid = ()=>{
  const key = `${__topic__}uuid`
  let uuid = localStorage.getItem(key)
  if(!uuid){
    uuid = uuidV4();
    localStorage.setItem(key,uuid)
  }
  return uuid
}
export function dataGather (
  page = "",
  event = "",
  properties = {},
  version = ""
) {
  if (!isReleaseEnv) {
    if (!page) {
      console.warn("埋点页面编号不能为空");
      return;
    }
    if (!event) {
      console.warn("埋点事件编号不能为空");
      return;
    }
  }
  const {shareSource,sourceUserId } = window.PAGE_PARAMS ||{}
  const uuid = localUUid()
  let proto = {uuid,shareSource,sourceUserId,...properties}
  const userNurseLoginInfo = JSON.parse(sessionStorage.getItem("userNurseLoginInfo")) || {}
  let data = {
    __topic__, //不要修改，统计用
    APIVersion: "0.6.0",
    userId: getUserInfo("id") || userNurseLoginInfo.id || "0",
    openId: getUserInfo("h5OpenId") || userNurseLoginInfo.h5OpenId || "",
    pageName: window.PAGE_PATH,
    eventTime: new Date().getTime(),
    screenHeight: document.documentElement.clientHeight,
    screenWidth: document.documentElement.clientWidth,
    page: page,
    event: event,
    properties: JSON.stringify(proto),
    version
  };
  logger.send(data);
  console.log(data)
};

export function newDataGather(shareType, shareId, shareName, shareChannel) { //2020.07.22新埋点
  dataGather(shareType,shareId,{shareName,shareChannel})
  // let store = isReleaseEnv ? "app-datagather-log-v01" : "jkhh-test-log";
  // let data = {
  //   __topic__: store, //不要修改，统计用
  //   __source__: "APP_H5",
  //   APIVersion: "0.6.0",
  //   uid: getUserInfo("id"),
  //   openId: getUserInfo("openId"),
  //   screenHeight: document.documentElement.clientHeight,
  //   screenWidth: document.documentElement.clientWidth,
  //   url: window.location.href,
  //   pageName: window.PAGE_PATH,
  //   eventName: "appPageBrowsing",
  //   pageTitle: document.title,
  //   platform: "H5",
  //   shareType: shareType,//活动，内容资讯，课程介绍
  //   shareId: shareId,//如果是单独的活动链接，则传值为活动的id，头条文章则为文章的id，课程介绍页则为课程id
  //   shareName: shareName,//如果是单独的活动链接，则传值为活动的名称，头条文章则为文章的标题，课程介绍页则为课程名称
  //   shareChannel: shareChannel,//分享出去的渠道，如微信，微博，知乎等.wechatFriend wechatFriendQ 各种群标识
  //   createtime: getNowFormatDate(),
  //   os: MD.os(),
  //   manufacturer: MD.mobile()
  //
  // };
  // buriedPointApi(data, store, host, store)
  //   .then(() => { })
  //   .catch(() => { });
}
